import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import RGA from '~/_shared/models/RGA'
import moment from 'moment'

export const state = {
  item: new RGA(),
  list: [],
  items: [],
  pdf: undefined,
  memoRequiredList: []
}

export const getters = {
  item: state => state.item,
  list: state => state.list,
  items: state => state.items,
  memoRequiredList: state => state.memoRequiredList,
  pdf: state => state.pdf
}

export const mutations = {
  ITEM (state, data) {
    state.item = Object.assign(new RGA(), data)
  },

  LIST (state, data) {
    state.list = data
  },

  ITEMS (state, data) {
    state.items = data
  },

  MEMO_REQUIRED_LIST (state, data) {
    state.memoRequiredList = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

export const actions = {

  async fetchList ({ commit }, filterData) {
    await axios.get(laroute.route('rga_list', { companyAbbr: store.getters['auth/company'], ...filterData }))
      .then(response => {
        commit('LIST', response.data.items)
      })
  },

  async create ({ commit }, formData) {
    await axios.post(laroute.route('rga_create', { companyAbbr: store.getters['auth/company'] }), { ...formData })
      .then(res => {
        if (res.status === 200) {
          commit('ITEM', res.data.data)
        }
      })
  },

  async getOne ({ commit }, id) {
    await axios.get(laroute.route('rga_get_one', { companyAbbr: store.getters['auth/company'], id }))
      .then(res => {
        res.data.data.created_at = moment(res.data.data.created_at).format('YYYY-MM-DD')
        if (res.data.data.expected_return_date) {
          res.data.data.expected_return_date = moment(res.data.data.expected_return_date).format('YYYY-MM-DD')
        }
        commit('ITEM', res.data.data)
      })
  },

  async getItems ({ commit }, id) {
    await axios.get(laroute.route('get_rga_items', { companyAbbr: store.getters['auth/company'], id }))
      .then(res => {
        commit('ITEMS', res.data)
      })
  },

  async getMemoRequiredList ({ commit }) {
    await axios.get(laroute.route('get_memo_required_list', { companyAbbr: store.getters['auth/company'] }))
      .then(res => {
        commit('MEMO_REQUIRED_LIST', res.data.data)
      })
  },

  async getPdf ({ commit }, { id }) {
    const { data } = await axios.post(laroute.route('rga_pdf', { companyAbbr: store.getters['auth/company'], id: id }), {}, { responseType: 'arraybuffer' })
    commit('PDF', data)
  },

  async deleteItem ({ commit }, itemId) {
    await axios.delete(laroute.route('rga_delete', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async deleteExpected ({ commit }, itemId) {
    await axios.delete(laroute.route('rga_delete_expected_item', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async deleteReceived ({ commit }, itemId) {
    await axios.delete(laroute.route('rga_delete_received_item', { companyAbbr: store.getters['auth/company'], id: itemId }))
  },

  async addItems ({ commit }, { id, expectedItems, receivedItems }) {
    await axios.post(laroute.route('rga_add_items', { companyAbbr: store.getters['auth/company'], id }), { expectedItems, receivedItems })
  },

  async update ({ commit }, { id, rga, rgaExpectedItems, rgaReceivedItems }) {
    await axios.patch(laroute.route('rga_update', { companyAbbr: store.getters['auth/company'], id }), { rga, rgaExpectedItems, rgaReceivedItems })
  },

  async addCreditMemo ({ commit }, rgaId) {
    await axios.post(laroute.route('rga_add_credit_memo', { companyAbbr: store.getters['auth/company'], id: rgaId }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/rga.js